import { useQuery } from '@tanstack/react-query';
import {
  getShowAuthPrivacyPolicy,
  PRIVACY_POLICY_API,
} from 'api/show-authenticated-privacy-policy';

export const useShowAuthPrivacyPolicy = () => {
  const { data, isLoading } = useQuery<number | undefined, Error>({
    queryKey: [PRIVACY_POLICY_API],
    queryFn: () => getShowAuthPrivacyPolicy(),
  });

  let showAuthPrivacyPolicy: boolean | undefined;

  // TODO: handle if error case
  if (data === 200) {
    showAuthPrivacyPolicy = true;
  } else if (data === 204) {
    showAuthPrivacyPolicy = false;
  }

  return {
    showAuthPrivacyPolicy,
    isLoading,
  };
};
